import { render, staticRenderFns } from "./addGamedetail.vue?vue&type=template&id=2b55ec48&"
import script from "./addGamedetail.vue?vue&type=script&lang=js&"
export * from "./addGamedetail.vue?vue&type=script&lang=js&"
import style0 from "./addGamedetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b55ec48')) {
      api.createRecord('2b55ec48', component.options)
    } else {
      api.reload('2b55ec48', component.options)
    }
    module.hot.accept("./addGamedetail.vue?vue&type=template&id=2b55ec48&", function () {
      api.rerender('2b55ec48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addGamedetail.vue"
export default component.exports